// Define un tipo genérico para el entorno

import { ENV } from "../interfaces/interfaces";

export function getEnvironment(): ENV {
    return window.projectEnvironment;
}